// utils/ensureFbSdk.js
export function ensureFbSdk(appId = '748347668239935', version = 'v24.0') {
  return new Promise((resolve) => {
    function init() {
      try { window.FB.init({ appId, cookie: true, xfbml: false, version }); } catch(e) {}
      resolve(window.FB);
    }
    if (window.FB) return init();
    // load SDK
    const s = document.createElement('script');
    s.src = 'https://connect.facebook.net/en_US/sdk.js';
    s.async = true; s.defer = true;
    s.onload = () => { if (window.FB) init(); };
    document.head.appendChild(s);
  });
}
